import { CircularProgress } from '@mui/material';

export default function InlineLoader(props: any) {
  return (
    <CircularProgress
      style={{ color: '#4B4B4B' }}
      {...{ size: 20, ...props }}
    />
  );
}
